import MuxPlayer from "@mux/mux-player-react";
import { graphql, useStaticQuery } from "gatsby";
import React, { useEffect, useState } from "react";
import siteConfig from "../../config/siteConfig";
import { MuxPoster, MuxVideo } from "../../models/videos/muxVideo";
import { getImagePresetUrl } from "../../utilities/image";

export interface VideoProps {
  title?: string;
  muxVideo?: MuxVideo;
  muxPoster?: MuxPoster;
}

interface MuxEnvironmentKeyResult {
  sanitySiteSettings: {
    muxEnvironmentKey?: string;
  };
}

const Video = (props: VideoProps) => {
  const { title, muxVideo, muxPoster } = props;

  const {
    sanitySiteSettings: { muxEnvironmentKey }
  } = useStaticQuery<MuxEnvironmentKeyResult>(graphql`
    query MuxEnvironmentKeyQuery {
      sanitySiteSettings {
        muxEnvironmentKey
      }
    }
  `);

  const [isConsentGiven, setIsConsentGiven] = useState(false);

  const getContentBlock = () => {
    if (muxVideo) {
      return (
        <MuxPlayer
          className="rounded-2xl overflow-hidden"
          accentColor="#187ee0"
          primaryColor="#f8fbfe"
          playbackId={muxVideo?.asset.playbackId}
          poster={
            muxPoster
              ? getImagePresetUrl(muxPoster, { width: 1232 }) ?? undefined
              : undefined
          }
          thumbnailTime={muxVideo?.asset.thumbTime}
          metadataVideoId={muxVideo?.asset.data.id}
          metadataVideoTitle={title}
          envKey={muxEnvironmentKey}
          disableTracking={!isConsentGiven || siteConfig.isDev}
          disableCookies={!isConsentGiven}
        />
      );
    }

    console.error("Unknown content type in Video block");
    return null;
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const consent = window?.cookiehub?.hasConsented?.("uncategorized");
      // TODO: Change "uncategorized" to "analytics" once classified MUX cookies as analytics in CookieHub dashboard
      // More details about categories: https://docs.cookiehub.com/getting-started/cookie-categories

      setIsConsentGiven(consent ?? false);
    }
  }, []);

  return <aside>{getContentBlock()}</aside>;
};

export default Video;

